import { SaleItemType } from '../../../../components/Search/interfaces/product-action.dto';
import {
  GetOrderSummaryOutput,
  GetOrderSummaryParams,
} from '../../../../services/modules/order/order.types';
import {
  OrderItemListGridItemDTO,
  OrderProduct,
} from '../../../orders/products/orderProducts.types';
import { AvailabilityEnum } from '../../ProductTypes';

export interface ProductActionsRequestParams {
  productColorId: string;
  orderId: string;
  availability?: AvailabilityEnum;
}

export interface ProductActionsResponseData {
  isShopping: boolean;
  productColorId: string;
  productId: string;
  productCode: string;
  productName: string;
}

export enum CodeMatchType {
  KIT_CODE = 'KIT_CODE',
  SKU_BARCODE = 'SKU_BARCODE',
  SKU_CODE = 'SKU_CODE',
  PRODUCT_COLOR_CODE = 'PRODUCT_COLOR_CODE',
  PRODUCT_CODE = 'PRODUCT_CODE',
}

export interface FindProductColorByAnyCodeResponse {
  productColorId: string;
  productId: string;
  productCode: string;
  productName: string;
  matchType?: CodeMatchType;
  skuId?: string;
  availability?: AvailabilityEnum;
  deliveryWindowId?: string;
}

interface FindKitByAnyCodeResponse {
  kitId: string;
  kitName: string;
  kitCode: string;
  matchType?: CodeMatchType;
}

export type ProductActionsSearchResponseData =
  | FindProductColorByAnyCodeResponse
  | FindKitByAnyCodeResponse;

export interface SearchProductParams {
  codeOrBarcodeOrName: string;
  isAdminSeller?: boolean;
  catalogId?: string;
  orderId?: string;
}

export enum ShopByMode {
  ADD = 'ADD',
  INCREMENT = 'INCREMENT',
}

export interface ShopByIncrementParams {
  orderId: string;
  code: string;
  filter: NonNullable<GetOrderSummaryParams['typedParams']>;
}

export enum ShopByOutcome {
  ADDED = 'ADDED',
  INCREMENTED = 'INCREMENTED',
  ALREADY_IN_ORDER = 'ALREADY_IN_ORDER',
}

export interface ShopByResultOutput {
  outcome: ShopByOutcome;
  saleItemType: SaleItemType;
  productColorId?: string;
  kitId?: string;
  orderProducts?: OrderProduct[];
  grid?: OrderItemListGridItemDTO[];
  summary?: GetOrderSummaryOutput;
  resolution?: FindProductColorByAnyCodeResponse;
}
